import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { calculateDeliveryCost } from "../api/deliveryService";

const DeliveryCostPage = () => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        originAddressId: "",
        destinationAddressId: ""
    });

    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.originAddressId || !formData.destinationAddressId) {
            setError("Please fill both address IDs.");
            return;
        }

        setLoading(true);
        setError(null);
        setResult(null);

        try {
            const response = await calculateDeliveryCost({
                originAddressId: Number(formData.originAddressId),
                destinationAddressId: Number(formData.destinationAddressId)
            });

            if (!response) {
                setError("No response from server.");
                return;
            }

            if (response.success === false) {
                setError(response.message || "Delivery calculation failed.");
                return;
            }

            setResult(response);
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                err?.message ||
                "Failed to calculate delivery price"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-2xl mx-auto p-6 bg-white rounded-xl shadow">
            <h2 className="text-2xl font-bold mb-6 text-center">
                🚚 Delivery Cost Calculator
            </h2>

            {/* ================= FORM ================= */}
            <form onSubmit={handleSubmit} className="space-y-4">

                <input
                    name="originAddressId"
                    placeholder="Origin Address ID"
                    value={formData.originAddressId}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                    required
                />

                <input
                    name="destinationAddressId"
                    placeholder="Destination Address ID"
                    value={formData.destinationAddressId}
                    onChange={handleChange}
                    className="w-full p-2 border rounded"
                    required
                />

                <button
                    type="submit"
                    className="w-full py-2 bg-blue-600 text-white rounded-lg"
                    disabled={loading}
                >
                    {loading ? "Calculating..." : "Calculate"}
                </button>
            </form>

            {/* ================= ERROR ================= */}
            {error && (
                <p className="text-red-500 mt-4 text-center">{error}</p>
            )}

            {/* ================= RESULT ================= */}
            {result && (
                <div className="mt-6 p-4 bg-gray-100 rounded">
                    <p><strong>Price:</strong> {result.price} €</p>
                    <p><strong>Distance:</strong> {result.distanceInKm} km</p>
                </div>
            )}
        </div>
    );
};

export default DeliveryCostPage;